export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Edit.vue?vue&type=template&id=cef3701c"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/Camp/Edit.vue?vue&type=template&id=cef3701c
// module id = 2700
// module chunks = 31